import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFactoryService, MessServiceService } from '@app/shared/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { GenerateReportFieldsService } from '../../core/services/generate-report-fields.service';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
})
export class GenerateReportComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscriptions: Subscription[] = [];

  constructor(
    private formFactory: FormFactoryService,
    public generateFields: GenerateReportFieldsService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messService: MessServiceService
  ) {}

  ngOnInit(): void {
    this.form = this.formFactory.createForm(this.generateFields.mainFields);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  generateReport() {
    const form = this.form.getRawValue();

    if (form.report_type === 'until_now') {
      form.date_from = '';
      form.date_to = '';
    }

    this.subscriptions.push(
      this.config.data['service']
        .export(form.date_from, form.date_to)
        .subscribe({
          next: (response: any) => {
            window.open(response.data, 'download_window');

            this.ref.close();
          },
          error: (err) => {
            this.messService.addError({
              detail: err.error.message,
            });
          },
        })
    );
  }
}
